
<template>
    <v-row>
        <v-col md="12">
            <v-autocomplete
                outlined
                dense
                v-model="query.driverGroups"
                :items="driverGroups"
                filled
                chips
                color="blue-grey lighten-2"
                item-text="name"
                placeholder="Select Driver Groups"
                item-value="id"
                multiple
                label="Driver Groups"
            >
                <template v-slot:selection="data">
                    <v-chip
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeDriverGroup(data.item)"
                    >
                        <v-avatar left>
                            <v-icon x-small>mdi-account-group-outline</v-icon>
                        </v-avatar>
                        {{ data.item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item.name"></v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                        </v-list-item-content>
                    </template>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col md="12">
            <v-autocomplete
                outlined
                dense
                v-model="query.councils"
                :items="councils"
                filled
                chips
                color="blue-grey lighten-2"
                item-text="name"
                placeholder="Select Councils"
                item-value="name"
                multiple
                label="Councils"
            >
                <template v-slot:selection="data">
                    <v-chip
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeCouncil(data.item)"
                    >
                        <v-avatar left>
                            <v-icon x-small>mdi-card-account-details-outline</v-icon>
                        </v-avatar>
                        {{ data.item }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-avatar>
                            <img :src="data.item.avatar">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item"></v-list-item-title>
                        </v-list-item-content>
                    </template>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col md="12">
            <v-autocomplete
                outlined
                dense
                v-model="query.rideTypes"
                :items="rideTypes"
                filled
                chips
                color="blue-grey lighten-2"
                item-text="name"
                placeholder="Select ride types"
                item-value="id"
                multiple
                label="Ride Types"
            >
                <template v-slot:selection="data">
                    <v-chip
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="removeRideType(data.item)"
                    >
                        <v-avatar left>
                            <v-icon x-small>mdi-car-outline</v-icon>
                        </v-avatar>
                        {{ data.item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item.name"></v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                        </v-list-item-content>
                    </template>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col md="12">
            <v-combobox
                outlined
                dense
                v-model="query.postCodes"
                :items="[]"
                hide-selected
                label="Post Codes"
                :placeholder="'Add Postcodes'"
                multiple
                persistent-hint
                small-chips
                
            >
                <template v-slot:no-data>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                Press <kbd>enter</kbd> to add post code in the list.
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-combobox>
        </v-col>
        <v-col md="6">
            <label>Locked? </label>
            <v-btn-toggle
                v-model="query.lockedOut"
                tile
                color="deep-purple accent-3"
                group
            >
                <v-btn :value="true">
                    Yes
                </v-btn>
                
                <v-btn :value="false">
                    No
                </v-btn>
            </v-btn-toggle>
        </v-col>
    </v-row>

</template>

<script>

import axios from 'axios'

export default {
    name: "DriverMessagingFilterBox",
    components: {},
    props: [
        'query', 'rideTypes', 'councils', 'driverGroups'
    ],
    data () {
      return {
      }
    },
    mounted() {
    },
    methods: {
        removeCouncil (item) {
            const index = this.query.councils.indexOf(item)
            if (index >= 0) this.query.councils.splice(index, 1)
        },
        removeRideType (item) {
            const index = this.query.rideTypes.indexOf(item.id)
            if (index >= 0) this.query.rideTypes.splice(index, 1)
        },
        removeDriverGroup (item) {
            const index = this.query.driverGroups.indexOf(item.id)
            if (index >= 0) this.query.driverGroups.splice(index, 1)
        },
    }
}
</script>

<style scoped lang="scss">

</style>